import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadReportExportListFailed, loadReportExportListSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, DEFAULT_ITEMS_OF_PAGE } from '../../../configs';

export default function* loadReportExportList(action) {
  try {
    const {
      payload = {
      },
    } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      page = 1,
    } = payload;
    const pool = {
      limit,
      page,
    };
    const url = `${BACKEND_URL}/resources/report-export`;
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadReportExportListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadReportExportListFailed());
      yield call(rejectActionPromise(action, data.data));
    }
    yield put(loadReportExportListSuccessful({
      data: [
        {
          id: 1,
          data: 'Получение данных от ГИС ГМП о штрафах',
          service: 'SID0003998 Электронный сервис государственной информационной системы о государственных и муниципальных платежах',
          source: 'СМЭВ СПб',
          created_at: '2024-12-12',
          status: '1',
        },
      ],
      meta: {
        limit: 10,
        page: 1,
        total: 5,
      },
    }));
  } catch (e) {
    yield put(loadReportExportListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
